import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  mainContainer: {
    flexDirection: "row",
    width: "100%",
    /* backgroundColor: "#0B87AB", */
    alignItems: "center",
    padding: 0,
    paddingHorizontal: 20,
    minHeight: 500,
    flex: 1,
  },

  rightColumnContainer: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    margin: 0,
  },
  cardContainer: {
    width: "100%",
    height: "auto",
    flexDirection: "row",
    backgroundColor: "#ABDCEA",
    padding: 8,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "space-evenly",
    margin: 0,
    marginBottom: 12,
  },
  cardRightColumnContainer: {
    width: "100%",
    flexDirection: "column",
    margin: 0,
    padding: 20,
  },

  imageSelo: {
    margin: 0,
    width: 80,
    aspectRatio: 2480 / 3507,
  },
  mainHeaderTxt: {
    color: "#D7F4FC",
    marginBottom: 20,
    marginTop: 12,
    fontSize: 30,
    fontWeight: "600",
  },
  titleTxtSelo: {
    fontSize: 22,
    color: "#043569",
  },
  subtitleTxtSelo: {
    fontSize: 18,
    marginBottom: 10,
    color: "#043569",
  },
  descriptionTxtSelo: {
    width: "100%",
    fontSize: 14,
    marginBottom: 15,
    textAlign: "justify",
  },
  btnSaibaMais: {
    padding: 10,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#0B87AB",
    marginHorizontal: 5,
    minWidth: 100,
  },
  btnComprar: {
    padding: 10,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#043569",
    marginHorizontal: 5,
    minWidth: 100,
  },
  containerRowBtns: {
    alignSelf: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginTop: 10,
  },
  txtBtn: {
    color: "#FFF",
  },

  pickerContainer: {
    marginBottom: 20,
  },
});

export default styles;
